import { Card, Typography, Button, Empty } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { saveAs } from "file-saver";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import globalRequest from "../../../utils/global/globalRequest";
import * as Apis from "../../../utils/helper/enum";
import { changeLoader } from "../../../redux/reducers/loader";

import {
  capitalizeName,
  checkPermissionAction,
  formatDateFunction,
} from "../../../utils/helper/utils";
import SettlePayout from "../../../Modal/SettlePayout";
import { addDeleteGetLocalStorage, storageKeys } from "../../../utils/global/localData";
import { jwtDecode } from "jwt-decode";

const DriverPayoutsDetail = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [permissionJson, setPermissionJson] = useState([]);
    useEffect(() => {
      const userAccess = addDeleteGetLocalStorage(
        storageKeys?.USER_TOKEN,
        {},
        "get"
      );
      let permissionJson = [];
      if (userAccess) {
        const decoded = jwtDecode(userAccess);
        permissionJson = decoded?.user?.rolePermission?.permissionJson;
        setPermissionJson(permissionJson);
      }
      if (!checkPermissionAction("Driver Payouts", permissionJson, "view")) {
        navigate("/");
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  const [payoutData, setPayoutData] = useState([]);
  const [isSettlePayoutModel, setIsSettlePayoutModel] = useState(false);
  const handelSettlePayoutModelOk = () => {
    if (id) getPayoutDetail(id);
    setIsSettlePayoutModel(false);
  };
  const handelSettlePayoutModelCancel = () => {
    setIsSettlePayoutModel(false);
  };
  const getPayoutDetail = async (id) => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_DRIVERS_PAYOUT.GET_DRIVERS_PAYOUT_DETAIL + "/" + id,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;
        setPayoutData(data);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    if (id) getPayoutDetail(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const exportAllVednorPayout = async () => {
    // console.log(payoutData); return false;
    dispatch(changeLoader(true));
    try {
      let exportData = [];
        for (let item of payoutData?.payoutItems ) {
          exportData.push({
            OrderId: item?.orderNumber,
            StartLocation: item?.payoutJson?.startAddress?.address,
            DestinationLocation: item?.payoutJson?.destinationAddress?.address,
            TotalKM	: item?.payoutJson?.distamceKm + ' KM',
            MinimunPayout: Number(item?.payoutJson?.minPayout).toFixed(2),
            MaximumDistance	: item?.payoutJson?.maxDistance + ` KM`,
            RateKM	: item?.payoutJson?.pricePerKm,
            PayoutAmount: Number(item?.payoutJson?.payoutAmount).toFixed(2)
          });
        }

        const headers = Object.keys(exportData[0]).join(","); // Extract headers
        const rows = exportData.map((row) =>
          Object.values(row)
            .map((value) => `"${value}"`) // Escape values
            .join(",")
        );
        const csvContent = [headers, ...rows].join("\n");

        // Create a Blob and save file
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        saveAs(blob, "Driver_payout_orders.csv");      
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  return (
    <>
      <Card>
        <div className="flex justify-between mb-4 gap-5">
          <div className="">
            <Typography className="text-xl font-semibold" align={"left"}>
              <LeftOutlined className="mr-2" onClick={() =>{
                sessionStorage.setItem('previousPath', location.pathname);
                navigate(-1)} 
              }/>
              Driver Payouts Detail
            </Typography>
          </div>
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full  text-left	 text-sm  text-gray-500">
            <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
              <tr>
                <th
                  scope="col"
                  className="px-3 py-3 whitespace-nowrap vertical-top"
                >
                  Sales Period
                </th>
                <th scope="col" className="px-3 py-3 vertical-top">
                  Driver Name
                </th>
                <th scope="col" className="px-3 py-3 vertical-top">
                  Expected Payout Date
                </th>
                <th scope="col" className="px-3 py-3 vertical-top">
                  Actual Payout Date
                </th>
                <th scope="col" className="px-3 py-3 vertical-top">
                  Expected Payout Amount
                </th>
                <th scope="col" className="px-3 py-3 vertical-top">
                  Actual Payout Amount
                </th>
                <th scope="col" className="px-3 py-3 vertical-top">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="bg-white border-b text-gray-700">
                <td className="px-3 py-4 vertical-top font-semibold cursor-pointer">
                  {formatDateFunction(
                    payoutData?.peroidStartDate,
                    "dd/mm/yyyy"
                  )}{" "}
                  To{" "}
                  {formatDateFunction(payoutData?.peroidEndDate, "dd/mm/yyyy")}
                </td>
                <td className="px-3 py-4 vertical-top">
                  {payoutData?.user?.firstName} {payoutData?.user?.lastName}
                </td>
                <td className="px-3 py-4 vertical-top">
                  {formatDateFunction(
                    payoutData?.expectedPayoutDate,
                    "dd/mm/yyyy"
                  )}
                </td>
                <td className="px-3 py-4 vertical-top">
                  {payoutData?.actualPayoutDate
                    ? formatDateFunction(
                        payoutData?.actualPayoutDate,
                        "dd/mm/yyyy"
                      )
                    : ""}
                </td>
                <td className="px-3 py-4 vertical-top">
                  {(payoutData?.expectedPayoutAmount)}
                </td>
                <td className="px-3 py-4 vertical-top">
                  {(payoutData?.actualPayoutAmount)}
                </td>
                <td className="px-3 py-4 vertical-top">
                  <span
                    className={`flex items-center ${
                      payoutData.status === "planned"
                        ? "bg-blue-50"
                        : "bg-green-50"
                    } text-green-200 text-center px-[12px] py-[8px] rounded w-full max-w-[76px] h-[32px]`}
                  >
                    {capitalizeName(payoutData?.status)}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="flex justify-end items-center my-5 gap-5">
            <div className="text-sm font-semibold">
              {payoutData?.payoutNotes
                ? `Note - ${payoutData?.payoutNotes}`
                : null}
            </div>
            {payoutData?.status !== "settled" ? (
              payoutData?.user?.driverPayoutDetail ? (                
                  <Button
                    type="primary"
                    size={14}
                    className="mx-1.5 cursor-pointer"
                    onClick={() => setIsSettlePayoutModel(true)}
                  >
                    Mark as settled
                  </Button>                
              ) : (
                "This driver does not have bank details."
              )
            ) : null}
            {
                (checkPermissionAction(
                  "Driver Payouts",
                  permissionJson,
                  "export"
                ) && payoutData?.payoutItems?.length>0) ? (
                  <Button
                    type="primary"
                    size={14}
                    className="mx-1.5 cursor-pointer"
                    onClick={exportAllVednorPayout}
                  >
                    Export
                  </Button>
                ) : null
              }  
          </div>
          <Card>
            <div className="relative overflow-x-auto">
              <table className="w-full  text-left	 text-sm  text-gray-500">
                <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="px-3 py-3 whitespace-nowrap vertical-top"
                    >
                      Order ID
                    </th>
                    <th scope="col" className="px-3 py-3 vertical-top">
                      Start Location
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3 vertical-top whitespace-nowrap"
                    >
                      Destination Location
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3 vertical-top whitespace-nowrap"
                    >
                      Total KM
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3 vertical-top whitespace-nowrap"
                    >
                      Minimun Payout
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3 vertical-top whitespace-nowrap"
                    >
                      Maximum Distance
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3 vertical-top whitespace-nowrap"
                    >
                      Rate/KM
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3 vertical-top whitespace-nowrap"
                    >
                      Payout Amount
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {payoutData?.payoutItems?.length ? (
                    payoutData?.payoutItems?.map((item, index) => (
                      <tr className="bg-white border-b text-gray-700">
                        <td className="px-3 py-4 vertical-top font-semibold cursor-pointer">
                          {item.orderNumber}
                        </td>
                        <td className="px-3 py-4 vertical-top">
                          {item?.payoutJson?.startAddress?.address}
                        </td>
                        <td className="px-3 py-4 vertical-top">
                          {item?.payoutJson?.destinationAddress?.address}
                        </td>
                        <td className="px-3 py-4 vertical-top">
                          {item?.payoutJson?.distamceKm} KM
                        </td>
                        <td className="px-3 py-4 vertical-top">
                          {(item?.payoutJson?.minPayout).toFixed(2)}
                        </td>
                        <td className="px-3 py-4 vertical-top">
                          {item?.payoutJson?.maxDistance} KM
                        </td>
                        <td className="px-3 py-4 vertical-top">
                          {item?.payoutJson?.pricePerKm}
                        </td>
                        <td className="px-3 py-4 vertical-top">
                          {(item?.payoutJson?.payoutAmount).toFixed(2)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={8} className="text-center mt-3">
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Card>
          <div className="my-4">
            {payoutData?.user?.driverPayoutDetail ? (
              <>
                <h2 className="text-lg font-semibold mb-3">Bank Details</h2>
                <div className="flex gap-2 items-center mb-2">
                  <span className="font-medium">Full Name - </span>
                  <span>
                    {capitalizeName(payoutData?.user?.firstName)}{" "}
                    {capitalizeName(payoutData?.user?.lastName)}
                  </span>
                </div>
                <div className="flex gap-2 items-center mb-2">
                  <span className="font-medium">Bank account number - </span>
                  <span>
                    {payoutData?.user?.driverPayoutDetail?.accountNumber}
                  </span>
                </div>
                <div className="flex gap-2 items-center mb-2">
                  <span className="font-medium">IBAN - </span>
                  <span>{payoutData?.user?.driverPayoutDetail?.IBAN}</span>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </Card>
      {isSettlePayoutModel && (
        <SettlePayout
          isOpen={isSettlePayoutModel}
          onOk={handelSettlePayoutModelOk}
          onCancel={handelSettlePayoutModelCancel}
          type={"driver"}
          payoutData={payoutData}
        />
      )}
    </>
  );
};
export default DriverPayoutsDetail;
